export { default } from './UserMobileMenu';



// WEBPACK FOOTER //
// ./src/components/base/UserMobileMenu/index.js